module.exports = __webpack_public_path__ + "img/index_banner.6faf8fe7.jpg";